export const trunk = {
  field: {
    my_ip: 'Мой IP адрес',
    zorra_ip: 'Zorra IP адрес',
    type: 'Направление',
    prefix: 'Префикс',
    state: 'Статус',
    trunk_type: 'Сервис'
  },

  trunk_type: {
    inc_voice: 'Входящие звонки',
    out_voice: 'Исходящие звонки',
    pbx_inc_voice: 'Входящие звонки АТС',
    pbx_out_voice: 'Исходящие звонки АТС',
    autocaller_inc_voice: 'Входящие звонки Автоинформер',
    autocaller_out_voice: 'Исходящие звонки Автоинформер',
    call_number_verification: 'Верификация номеров'
  },

  type: {
    outgoing: 'Исходящий',
    caller: 'Caller',
    incoming: 'Входящий',
    inc_voice: 'Входящие звонки',
    out_voice: 'Исходящие звонки',
    pbx_inc_voice: 'Входящие звонки АТС',
    pbx_out_voice: 'Исходящие звонки АТС',
    autocaller_inc_voice: 'Входящие звонки Автоинформер',
    autocaller_out_voice: 'Исходящие звонки Автоинформер',
    amo_inc_voice: 'Виджет amoCRM входящие звонки',
    amo_out_voice: 'Виджет amoCRM исходящие звонки',
    kommo_inc_voice: 'Виджет Kommo CRM входящие звонки',
    kommo_out_voice: 'Виджет Kommo CRM исходящие звонки',
    call_number_verification: 'Верификация номеров',
    predictive_inc_voice: 'Предиктивные входящие звонки',
    predictive_out_voice: 'Предиктивные исходящие звонки',
    voice_number_verification: 'Верификация по аудио-коду',
    phone_number_verification: 'Верификация по входящему звонку',
    all: 'Все'
  },

  modal: {
    edit: 'Редактировать SIP-транк',
    remove: {
      content: 'Вы уверены, что хотите удалить транк {name}?'
    },
    myip_tooltip: 'Основной IP адрес не доступен для редактирования.',
    ip_exist: 'IP адрес уже занят'
  },

  button: {
    create: 'Создать транк',
    tooltip: 'Пополните баланс, чтобы создать транк',
    show_default_trunks: 'Показать служебные транки'
  },

  errors: {
    trunk_limit: 'Превышен лимит транков',
    ip_exist: 'IP адрес уже занят'
  },

  show_all: 'Показать все'
};
